
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./SchoolManagement.css";
import img1 from "../assets/images/school-management.jpeg"
const managementPillars = [
  {
    number: "01",
    icon: "bi-mortarboard-fill",
    title: "Academic Excellence",
    description:
      "Maintaining high academic standards and ensuring effective implementation of the curriculum."
  },
  {
    number: "02",
    icon: "bi-person-workspace",
    title: "Leadership & Administration",
    description:
      "Providing academic and administrative leadership for the smooth functioning of school activities."
  },
  {
    number: "03",
    icon: "bi-people-fill",
    title: "Staff Collaboration",
    description:
      "Encouraging teaching and non-teaching staff to work together in a positive and inclusive environment."
  },
  {
    number: "04",
    icon: "bi-lightbulb-fill",
    title: "Continuous Improvement",
    description:
      "Promoting better teaching practices, staff development and meaningful co-curricular activities."
  },
  {
    number: "05",
    icon: "bi-heart-fill",
    title: "Student Welfare",
    description:
      "Giving importance to student welfare, confidence, discipline and overall development."
  },
  {
    number: "06",
    icon: "bi-chat-dots-fill",
    title: "Parent Partnership",
    description:
      "Encouraging effective communication and cooperation between the school, parents and stakeholders."
  }
];

function SchoolManagement() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".school-management-page .animate-on-scroll"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animation");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="school-management-page">

      {/* HERO SECTION */}
      <section className="management-hero">
        <div className="container">
          <div className="management-hero-content animate-on-scroll">

            <h1>
              School <span>Management</span>
            </h1>

            <p>
              Strong leadership, shared responsibility and a commitment
              to educational excellence.
            </p>

            <div className="management-breadcrumb">
              <Link to="/">Home</Link>
              <i className="bi bi-chevron-right"></i>
              <span>School Management</span>
            </div>
          </div>
        </div>
      </section>

      {/* INTRODUCTION */}
      <section className="management-intro section-space">
        <div className="container">
          <div className="row align-items-center g-5">

        <div className="col-lg-5">
  <div className="management-visual animate-on-scroll animate-left">
    <img
      src={img1}
      alt="Air Force School Management and Leadership"
      className="management-image"
    />
  </div>
</div>

            <div className="col-lg-7">
              <div className="management-intro-content animate-on-scroll animate-right">

                <span className="management-label">
                  <i className="bi bi-stars"></i>
                  About Our Management
                </span>

                <h2>
                  Guiding the School Towards
                  <span> Excellence</span>
                </h2>

                <p>
                  Air Force School, Vayu Sena Nagar, Nagpur, functions
                  under the guidance and supervision of the Indian Air
                  Force's designated educational authorities. The school
                  management is committed to maintaining high standards
                  of academic excellence, discipline, and professional
                  integrity.
                </p>

                <p>
                  Through collective efforts, transparent administration,
                  and a shared commitment to educational excellence,
                  the management strives to provide quality education
                  and nurture responsible, confident, and disciplined
                  citizens.
                </p>

                <div className="management-highlight">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Committed to quality education and student development.</span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* LEADERSHIP */}
      <section className="management-leadership section-space">
        <div className="container">
          <div className="management-section-heading text-center animate-on-scroll">
            <span className="management-label">
              <i className="bi bi-person-badge-fill"></i>
              Leadership & Teamwork
            </span>

            <h2>
              Working Together for
              <span> Student Success</span>
            </h2>

            <p>
              Every member of the school community contributes towards
              creating a supportive and student-centred environment.
            </p>
          </div>

          <div className="row g-4 mt-3">

            <div className="col-lg-6">
              <div className="leadership-card principal-card animate-on-scroll animate-left">
                <div className="leadership-card-icon">
                  <i className="bi bi-person-video3"></i>
                </div>

                <span className="leadership-number">01</span>
                <span className="leadership-subtitle">ACADEMIC & ADMINISTRATIVE LEADERSHIP</span>

                <h3>The Principal</h3>

                <p>
                  The Principal provides academic and administrative
                  leadership, ensuring the effective implementation
                  of the curriculum, smooth functioning of school
                  activities, and overall development of students.
                </p>

                <div className="leadership-bottom-line"></div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="leadership-card staff-card animate-on-scroll animate-right">
                <div className="leadership-card-icon">
                  <i className="bi bi-people-fill"></i>
                </div>

                <span className="leadership-number">02</span>
                <span className="leadership-subtitle">COLLABORATION & SUPPORT</span>

                <h3>Teaching & Non-Teaching Staff</h3>

                <p>
                  The teaching and non-teaching staff work collaboratively
                  to create a positive, inclusive, and student-centred
                  learning environment.
                </p>

                <div className="leadership-bottom-line"></div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* MANAGEMENT PRIORITIES */}
      <section className="management-priorities section-space">
        <div className="container">

          <div className="management-section-heading text-center animate-on-scroll">
            <span className="management-label">
              <i className="bi bi-grid-fill"></i>
              Our Management Priorities
            </span>

            <h2>
              Principles That
              <span> Guide Our Journey</span>
            </h2>

            <p>
              A shared focus on quality education, student welfare
              and continuous institutional improvement.
            </p>
          </div>

          <div className="row g-4 mt-3">
            {managementPillars.map((item) => (
              <div className="col-md-6 col-lg-4" key={item.number}>
                <div className="management-pillar-card animate-on-scroll">
                  <div className="pillar-top">
                    <div className="pillar-icon">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <span>{item.number}</span>
                  </div>

                  <h3>{item.title}</h3>
                  <p>{item.description}</p>

                  <div className="pillar-line"></div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>


    </main>
  );
}

export default SchoolManagement;
